<template>
  <section>

    

    <ul>
      <li v-for="item of collection" :key="item.caption">
        <figure>
          <img :src="item.imgSrc" :alt="item.caption">
          <figcaption>
            {{item.caption}}
          </figcaption>
        </figure>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: "redesigned-workshops",

  data: () => ({
    collection: [
      {
        imgSrc: require("../assets/icn-14.svg"),
        caption: "16 modularized workshops that can be delivered in any combination",
      },
      {
        imgSrc: require("../assets/icn-guides.svg"),
        caption: "Facilitator’s and participant’s guides",
      },
      {
        imgSrc: require("../assets/icn-timed instructions.svg"),
        caption: "Minute-by-minute instructions for facilitators leading each workshop.",
      },
      {
        imgSrc: require("../assets/icn-lecture points.svg"),
        caption: "Specific exercises, activities, and lecture points",
      },
      {
        imgSrc: require("../assets/icn-structered support.svg"),
        caption: "Structured pedagogy support throughout",
      },
    ],
  })
}
</script>

<style scoped>
section {
  background: var(--secondary-color);
  color: white;
}

.heading {
  background: var(--success-color);
  padding: 15px 90px;
  color: white;
  font-size: 20px;
  font-weight: 600;
}
.sm .heading,
.md .heading {
  padding: 10px 60px;
  font-size: 14px;
}
.xs .heading {
  padding: 10px 30px;
  font-size: 14px;
}

ul {
  display: flex;
  padding: 90px;
  justify-content: space-evenly;
}
.md ul,
.sm ul {
  padding: 60px;
}
.md ul {
  justify-content: space-around;
}
.sm ul {
  justify-content: space-between;
}
.xs ul {
  flex-direction: column;
  align-items: flex-start;
  padding: 30px;
}

.xs li {
  margin-bottom: 15px;
}
.xs li:last-child {
  margin-bottom: 0;
}

li figure {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.xs li figure {
  flex-direction: row;
  text-align: left;
  align-items: center;
}
li img {
  width: 7rem;
  height: 7rem;
  margin-bottom: 20px;
}
.sm li img,
.md li img {
  width: 4rem;
  height: 4rem;
}
.xs li img {
  width: 3rem;
  height: 3rem;
  margin: 0 15px 0 0;
}

li figcaption {
  max-width: 10rem;
  line-height: 1.3;
}
.sm li figcaption,
.md li figcaption {
  font-size: 12px;
  max-width: 7rem;
}
.xs li figcaption {
  max-width: unset;
}
</style>